var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-card',{staticClass:"q-pa-md",staticStyle:{"border-color":"#0086e6"},attrs:{"flat":"","bordered":""}},[_c('p',{staticClass:"text-body1 text-bold"},[_vm._v("Performance mês a mês")]),_c('div',{staticStyle:{"position":"relative","min-height":"326px","max-height":"auto"}},[_c('canvas',{attrs:{"id":"commission-full-double-bar-chart"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }